export default "__VITE_ASSET__0DJMdokQ__"